import React from 'react'
import { IconButton, Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from '@mui/icons-material'

function MyTablePaginationActions(props) {
  const theme = useTheme()
  const { count, page, rowsPerPage, onPageChange } = props

  const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1)

  const handleFirstPageButtonClick = (event) => onPageChange(event, 0)
  const handleBackButtonClick = (event) => onPageChange(event, page - 1)
  const handleNextButtonClick = (event) => onPageChange(event, page + 1)
  const handleLastPageButtonClick = (event) => onPageChange(event, lastPage)

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton type='button' onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label='first page'>
        {theme.direction === 'rtl' ? <LastPage /> : <FirstPage />}
      </IconButton>
      <IconButton type='button' onClick={handleBackButtonClick} disabled={page === 0} aria-label='previous page'>
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton type='button' onClick={handleNextButtonClick} disabled={page >= lastPage} aria-label='next page'>
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton type='button' onClick={handleLastPageButtonClick} disabled={page >= lastPage} aria-label='last page'>
        {theme.direction === 'rtl' ? <FirstPage /> : <LastPage />}
      </IconButton>
    </Box>
  )
}

export default MyTablePaginationActions
